import Vue from 'vue'
import axios from 'axios'

const Plugin = {}

Plugin.install = function (Vue, options) {
  Vue.prototype.$axios = axios
}

Vue.use(Plugin)

export default Plugin
